import React, { useState, useRef, useEffect, startTransition, useMemo } from "react";
import "./index.scss";
import { ReactComponent as Hamburger } from "../../../../assets/svgs/hamburger.svg";
import { ReactComponent as Bell } from "../../../../assets/svgs/bell.svg";
import { ReactComponent as UserIcon } from "../../../../assets/svgs/user-icon.svg";
import { ReactComponent as IndsLogo } from "../../../../assets/svgs/inds-logo.svg";
import { ReactComponent as Overview } from "../../../dashboard/assets/Overview.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/svgs/searchIcon.svg";
import indsLogo from "../../../inds-pre-login-screen/assets/png/inds_logo.png"
import DSSButton from "../../../../ui/building-blocks/atoms/dss-button";
import DSSTextInput from "../../../../ui/building-blocks/atoms/dss-textinput";
import DSSDropdown from "../../../../ui/building-blocks/atoms/dss-dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { useDssContext } from "../../../../DSSContext";
import DSSModal from "../../../../ui/building-blocks/atoms/dss-modal";
import INDSLoginModal from "./modal/inds-login";
import AssociateHoneywellIdModal from "./modal/associate-honeywell-modal";
import useAuth from "../../../../auth-provider/hooks/useAuth";
import { CREATE_ACCOUNT_URL } from "../../../../interceptors/constant";
import { globalSearchOptions, ROUTER_PATHS as SUBS_ROUTES } from "../../../../modules/subscriptions/constant/constant";
import { INDS_CUSTOMER, INDS_OP_ADMIN } from "../../../user-care/constant/operator-admin-contant";
import { ProfileModal } from "../../../my-account/component/profile/profile-modal";
import BroadcastMsgList from "../../../inds-pre-login-screen/component/overview/broadcast-msg-list";
import { getBroadcastMessageList } from "../../../broadcast-message/api/api";
import { searchCriteriaGeneralMessages } from "../../../broadcast-message/services/boradcast-services";
import DSSLoader from "../../../../ui/building-blocks/atoms/dss-loader/dss-loader";

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { translate, userDetail, selectedCustomer, setSelectedCustomer } = useDssContext();

    const roleIds = useMemo<number[]>(() => {
        const assoc: any[] = ((userDetail as any)?.userCustAssociation) || [];
        const firstRoleId = Number(assoc?.[0]?.roleId);
        if (!Number.isNaN(firstRoleId)) return [firstRoleId];
        return [];
    }, [userDetail]);

    const isLocation = location.pathname.startsWith("/userlogin")||location.pathname.startsWith("/guest");
    const isGlobalSearch = location.pathname.startsWith(SUBS_ROUTES.GlobalSearch) || location.pathname.startsWith(SUBS_ROUTES.GlobalSearchMain);
    const isGuestUser = location.pathname.startsWith("/guest");
    const customers = userDetail?.customers || [];
    const isCustomerRole = roleIds.includes(INDS_CUSTOMER);
    const showAccountSelector = isCustomerRole && location.pathname.startsWith('/userlogin') && customers.length > 1;

    const hasSubscriptionMenuAccess = roleIds.some(rid => rid !== INDS_CUSTOMER && rid !== INDS_OP_ADMIN);
    const showHeaderSearch = (isLocation || isGlobalSearch) && hasSubscriptionMenuAccess;
    const { active, setActive } = useDssContext();
    const [showDropdown, setShowDropdown] = useState(false);
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);
    const [showStandaloneNotificationPanel, setShowStandaloneNotificationPanel] = useState(false);
    const [standaloneNotifications, setStandaloneNotifications] = useState<any[] | null>(null);
    const [nonStandaloneNotifications, setNonStandaloneNotifications] = useState<any[] | null>(null);
    const [notificationMessages, setNotificationMessages] = useState<any[] | null>(null);
    const [notificationLoader, setNotificationLoader] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [showINDSLoginModal, setShowINDSLoginModal] = useState(false);
    const [showAssociateModal, setShowAssociateModal] = useState(false);
        const { logout } = useAuth();

    // Global search state (shown in header, results rendered by page)
    const [selectedOption, setSelectedOption] = useState<string>(globalSearchOptions[2].value);
    const [inputValue, setInputValue] = useState("");

    // Reset or sync search inputs on route changes
    useEffect(() => {
        const onGlobalSearchRoute =
            location.pathname.startsWith(SUBS_ROUTES.GlobalSearch) ||
            location.pathname.startsWith(SUBS_ROUTES.GlobalSearchMain);

        if (onGlobalSearchRoute) {
            const params = new URLSearchParams(location.search);
            const type = params.get('searchType') || globalSearchOptions[2].value;
            const q = params.get('searchText') || '';
            setSelectedOption(type);
            setInputValue(q);
            sessionStorage.setItem('lastGlobalSearch', JSON.stringify({ searchType: type, searchText: q }));
        } else {
            setSelectedOption(globalSearchOptions[2].value);
            setInputValue('');
        }
    }, [location.pathname, location.search]);

    const handleMenuClick = () => {
        if (active === '')
            setActive(' active');
        else
            setActive('');
    };
    useEffect(() => {
        if (window.location.search.includes('landing=AssociateHoneywellID')) {
            setShowDropdown(true);
        }

    }, []);

    useEffect(() => {
        if (!selectedCustomer && customers.length === 1) {
            setSelectedCustomer(String(customers[0].customerRefSeq));
        }
    }, [customers, selectedCustomer, setSelectedCustomer]);
     
    // Close dropdown if clicked outside
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (showProfileModal) {
                return;
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowDropdown(false);
                setShowUserDropdown(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showProfileModal]);
    const handlecreateHoneywellClick = () => {
        setShowDropdown(false);
        window.open(CREATE_ACCOUNT_URL, "_blank", "noopener,noreferrer");

    }
    const handleLogout = () => {
        logout();
    };

    const handleBellClick = async () => {
        if (showNotificationPanel || showStandaloneNotificationPanel) {
            setShowNotificationPanel(false);
            setShowStandaloneNotificationPanel(false);
        } else {
            setNotificationLoader(true);
            try {
                const response = await getBroadcastMessageList({
                    criterias: searchCriteriaGeneralMessages()
                });
                
                if (response.content && response.content.length > 0) {
                    const messages = [...(response.content as any[])].sort((left, right) => {
                        const leftTime = new Date(left?.startDate ?? 0).getTime();
                        const rightTime = new Date(right?.startDate ?? 0).getTime();
                        return rightTime - leftTime;
                    });
                    
                    // Separate messages based on standalone control flag
                    const standalone = messages.filter((msg: any) => 
                        msg.broadcastControls?.some((control: any) => 
                            control.controlName === 'standalone' && control.controlFlag === 'Y'
                        )
                    );
                    
                    const nonStandalone = messages.filter((msg: any) => 
                        !msg.broadcastControls?.some((control: any) => 
                            control.controlName === 'standalone' && control.controlFlag === 'Y'
                        )
                    );
                    
                    // Show standalone messages first if they exist
                    if (standalone.length > 0) {
                        setStandaloneNotifications(standalone);
                        setNonStandaloneNotifications(nonStandalone.length > 0 ? nonStandalone : null);
                        setShowStandaloneNotificationPanel(true);
                    }
                    // If no standalone messages, show non-standalone directly
                    else if (nonStandalone.length > 0) {
                        setNotificationMessages(nonStandalone);
                        setShowNotificationPanel(true);
                    }
                } 
            } catch (err: any) {
            } finally {
                setNotificationLoader(false);
            }
        }
    };

    const handleHeaderSearch = () => {
        const params = new URLSearchParams();
        params.set('searchType', selectedOption);
        params.set('searchText', inputValue.trim());
        startTransition(() => {
            navigate({ pathname: SUBS_ROUTES.GlobalSearchMain, search: params.toString() });
        });
    };
        
    // const handleForgotPassword = () => {
    //     setShowINDSLoginModal(false);
    // };
    return (
        <div className="header" data-testid="header-container">
            {notificationLoader && <DSSLoader id="header-loader" />}
            <div className="header_left">
                <DSSButton
                    id="hamburger-menu"
                    variant="link"
                    className="header_signin"
                    iconPosition="left"
                    icon={<Hamburger width={20} height={20} />}
                    onClick={handleMenuClick}
                />
                <div className="header_logo"                  
                 onClick={() => navigate(isLocation ? "/userlogin/overview" : "/prelogin/overview")}
>
                    <IndsLogo className="header_logo-image" width={84} height={40} />
             
                    {/* <img
                        src={indsLogo||"https://inds.epicinds.com/epic/images/newDesign/inds_logo.png"}
                        alt="INDS Logo"
                        className="header_logo-image"
                        width={84}
                        height={40}
                    /> */}
                </div>
                <div className="header__title">
                    {translate('IndsTitle')}
                </div>
            </div>
            <div className="header_right">
                {showAccountSelector && (
                    <div className="header_account_selector">
                        <DSSDropdown
                            options={customers.map((customer: any) => ({
                                value: String(customer.customerRefSeq),
                                label: customer.customerName,
                            }))}
                            value={selectedCustomer || String(customers[0]?.customerRefSeq || '')}
                            onChange={(value: string) => setSelectedCustomer(value)}
                            placeholder="Select Account"
                            id="header-account-dropdown"
                            className="header-account-dropdown"
                        />
                    </div>
                )}
                {showHeaderSearch && (
                    <div className="header_search" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <DSSDropdown
                            options={globalSearchOptions}
                            value={selectedOption}
                            onChange={(val: string) => {
                                setSelectedOption(val);
                                setInputValue('');
                            }}
                            placeholder="Search by"
                            id="header-search-dropdown"
                            className="global-search-dropdown"
                        />
                        <div style={{ position: 'relative' }} onKeyDown={(e: any) => {
                            if (e.key === 'Enter' && inputValue.trim()) {
                                handleHeaderSearch();
                            }
                        }}>
                            <DSSTextInput
                                type="text"
                                value={inputValue}
                                placeholder="Search"
                                onChange={e => setInputValue(e.target.value)}
                                id={'header-subscription-search-input'}
                                endIcon={
                                    <DSSButton
                                        id="header-search-text-button"
                                        variant="secondary"
                                        className="global-search-text-button "
                                        onClick={handleHeaderSearch}
                                        disabled={!inputValue.trim()}
                                    >
                                        <SearchIcon width={30} height={30}/>
                                    </DSSButton>
                                }
                                style={{ width: 260 }}
                            />
                        </div>
                    </div>
                )}
                {isLocation && <DSSButton
                    id="bell"
                    variant="link"
                    className="header_signin"
                    iconPosition="left"
                    icon={<Bell width={20} height={20} />}
                    onClick={handleBellClick}
                    data-testid="notification-bell-button"
                />}
                <div className="user-dropdown-container" ref={dropdownRef}>
                    {isLocation && (isGuestUser || userDetail?.firstName) ? (
                        <>
                            <DSSButton
                                className="header_signin"
                                variant="tertiary"
                                iconPosition="left"
                                icon={<UserIcon width={20} height={20} />}
                                onClick={() => setShowUserDropdown((prev) => !prev)} id="user-name-btn"            >
                                {isGuestUser ? "Guest User" : userDetail?.firstName}
                            </DSSButton>
                            {showUserDropdown && (
                                <div className="user-dropdown" style={{ width: "160px" }}>
                                    <DSSButton
                                        variant="secondary"
                                        className="dropdown-btn"
                                        iconPosition="left"
                                        onClick={() => {
                                            setShowUserDropdown(false);
                                            setShowProfileModal(true);
                                        }}
                                        icon={<UserIcon width={20} height={20} style={{ marginRight: 8 }} />}
                                        id="profileBtn"
                                    >
                                        Profile
                                    </DSSButton>
                                    <DSSButton
                                        variant="secondary"
                                        className="dropdown-btn"
                                        iconPosition="left"
                                           onClick={handleLogout}

                                        icon={<Overview width={20} height={20} style={{ marginRight: 8 }} />}
                                        id="logoutBtn"
                                    >
                                        Logout
                                    </DSSButton>
                                </div>
                            )}
                            <DSSModal
                                id="profile-modal"
                                isOpen={showProfileModal}
                                isShowClose={true}
                                onClose={() => setShowProfileModal(false)}
                            >
                                <ProfileModal onClose={() => setShowProfileModal(false)} />
                            </DSSModal>
                        </>
                    ) : (
                        <>
                            <DSSButton
                                id="sign-in"
                                variant="secondary"
                                className="header_signin"
                                iconPosition="left"
                                icon={<UserIcon width={20} height={20} />}
                                onClick={() => {
                                    setShowDropdown((prev) => !prev);
                                }}
                            >
                                {translate('signIn')}
                            </DSSButton>

                            {showDropdown && (
                                <div className="user-dropdown">
                                    <DSSButton
                                        variant="secondary"
                                        className="dropdown-btn"
                                        iconPosition="left"
                                        icon={<Overview width={20} height={20} style={{ marginRight: 8 }} />}
                                        onClick={() => {
                                            window.location.href = window.location.origin + '/authorize';
                                        }}
                                        id={"honeywellLogin"}>
                                        {translate('honeywellLogin')}
                                    </DSSButton>
                                    <DSSButton
                                        variant="secondary"
                                        className="dropdown-btn"
                                        iconPosition="left"
                                        icon={<Overview width={20} height={20} style={{ marginRight: 8 }} />}
                                        onClick={handlecreateHoneywellClick}
                                        id={"createHoneywellId"}>
                                        {translate('createHoneywellId')}
                                    </DSSButton>
                                    <DSSButton
                                        variant="secondary"
                                        className="dropdown-btn"
                                        iconPosition="left"
                                        onClick={() => {
                                            setShowAssociateModal(true);
                                            setShowDropdown(false);
                                        }}
                                        icon={<Overview width={20} height={20} style={{ marginRight: 8 }} />}
                                        id={""}>
                                        {translate('associateHoneywellId')}
                                    </DSSButton>
                                    {/* <DSSButton
                                        id="indsLogin"
                                        variant="secondary"
                                        className="dropdown-btn"
                                        iconPosition="left"
                                        onClick={() => {
                                            setShowINDSLoginModal(true);
                                            setShowDropdown(false);
                                        }}
                                        icon={<Overview width={20} height={20} style={{ marginRight: 8 }} />}
                                    >
                                        {translate('indsLogin')}
                                    </DSSButton> */}
                                </div>
                            )}
                            {/* <DSSModal
                                id="inds-login-modal"
                                isOpen={showINDSLoginModal}
                                isShowClose={true}
                                onClose={() => setShowINDSLoginModal(false)}
                            >
                                <INDSLoginModal
                                    onClose={() => setShowINDSLoginModal(false)}
                                    onForgotPassword={handleForgotPassword}
                                />
                            </DSSModal> */}
                            <DSSModal
                                id="associate-honeywell-id-modal"
                                isOpen={showAssociateModal}
                                isShowClose={true}
                                onClose={() => setShowAssociateModal(false)}
                            >
                                <AssociateHoneywellIdModal
                                    onClose={() => setShowAssociateModal(false)}
                                />
                            </DSSModal>
                            
                        </>
                    )}
                </div>
                  {/* Standalone Notification Modal */}
            <DSSModal
                id="standalone-notification-panel-modal"
                isOpen={showStandaloneNotificationPanel}
                isShowClose={false}
                
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                   {standaloneNotifications && standaloneNotifications.length > 0 ? (
                        <BroadcastMsgList 
                            dataList={standaloneNotifications} 
                            buttonLabel={nonStandaloneNotifications && nonStandaloneNotifications.length > 0 ? "Next" : "Close"} 
                            Close={() => {
                                setShowStandaloneNotificationPanel(false);
                                // Show non-standalone messages after standalone modal closes
                                if (nonStandaloneNotifications && nonStandaloneNotifications.length > 0) {
                                    setNotificationMessages(nonStandaloneNotifications);
                                    setShowNotificationPanel(true);
                                } else {
                                    setStandaloneNotifications(null);
                                }
                            }} 
                        />
                    ) : null}
                </div>
            </DSSModal>

            {/* Non-Standalone Notification Modal */}
            <DSSModal
                id="notification-panel-modal"
                isOpen={showNotificationPanel}
                isShowClose={false}
               
                style={{
                    position: 'relative',
                    left: 0,
                    top: 0,
                    borderRadius: 0
                } as any}
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                   {notificationMessages && notificationMessages.length > 0 ? (
                        <BroadcastMsgList dataList={notificationMessages} buttonLabel="Close" Close={() => {
                            setShowNotificationPanel(false);
                            setNotificationMessages(null);
                        }} />
                    ) : null}
                </div>
            </DSSModal>
            </div>

           

           
        </div>
    );
};

export default Header;